// extracted by mini-css-extract-plugin
export var md = "768px";
export var shared = "\"../../../shared.module.css\"";
export var textareaIn = "Textarea_textareaIn__dtbYO";